import { render, staticRenderFns } from "./LimitedTimeTaskItem.vue?vue&type=template&id=2e115656&scoped=true&"
import script from "./LimitedTimeTaskItem.vue?vue&type=script&lang=js&"
export * from "./LimitedTimeTaskItem.vue?vue&type=script&lang=js&"
import style0 from "./LimitedTimeTaskItem.vue?vue&type=style&index=0&id=2e115656&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e115656",
  null
  
)

export default component.exports